/**
 * Полная перезагрузка страницы с очисткой кешей.
 *
 * Сбрасывает Cache Storage и регистрации service worker'ов, чтобы после обновления
 * версии системы браузер взял свежие ассеты, а не устаревшие из кеша. localStorage и
 * sessionStorage не трогаем — там живут авторизация и настройки пользователя.
 */
export const hardReload = async (): Promise<void> => {
  try {
    if ('caches' in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } finally {
    // Перезагружаем в любом случае: даже если очистка кеша частично не удалась,
    // пользователь должен получить попытку восстановления
    window.location.reload();
  }
};
